import { BrandKit } from 'types'
import { getInitials } from 'utils'
import Styles from './BrandKitLogo.module.scss'
import { Text, TextVariant } from 'blaze-ui/Text/Text'

interface Props {
  brandKit: BrandKit
  size?: number
  textVariant?: TextVariant
}

export const BrandKitLogo = ({ brandKit, size, textVariant }: Props) => {
  const { brand_visual_kit, websites } = brandKit
  const primaryLogoUrl = brand_visual_kit?.primary_logo?.url
  const favicon = websites?.find((website) => website.favicon)?.favicon

  const logoUrl = favicon || primaryLogoUrl

  if (!logoUrl) {
    return (
      <span
        className={Styles.avatar}
        style={{
          width: size ? `${size}px` : 'auto',
          height: size ? `${size}px` : 'auto',
        }}
      >
        <Text variant={textVariant}>{getInitials(brandKit?.name)}</Text>
      </span>
    )
  }

  return (
    <img
      className={Styles.avatar}
      src={logoUrl}
      alt={getInitials(brandKit?.name)}
      style={{
        width: size ? `${size}px` : '100%',
        height: size ? `${size}px` : 'auto',
      }}
    />
  )
}
